import { iProfile } from '@/entities/profile/profile.types';
import Profile from '@/entities/profile/profile';
import { iFirestoreProfileModel } from '../firestore.types';

const USER_COLLECTION = 'user';

export class FirestoreProfileModel implements iFirestoreProfileModel {
  private db: firebase.firestore.Firestore;

  constructor(db: firebase.firestore.Firestore) {
    this.db = db;
  }

  async findByUserIdOrSlug(userIdOrSlug: string): Promise<iProfile> {
    let data;
    const doc = await this.db.collection(USER_COLLECTION)
      .doc(userIdOrSlug)
      .get();

    if (doc.exists) {
      data = doc.data();

      return new Profile(
        data!.id,
        data!.gamertag,
        data!.profilePic,
        data!.profileCover,
        data!.slug,
      );
    }

    const snapshot = await this.db.collection(USER_COLLECTION)
      .where('slug', '==', userIdOrSlug.trim().toLowerCase())
      .get();

    if (snapshot.empty) {
      throw new Error('user_does_not_exists');
    }

    data = snapshot.docs[0].data();

    return new Profile(
      data!.id,
      data!.gamertag,
      data!.profilePic,
      data!.profileCover,
      data!.slug,
    );
  }
}
